exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unarchive-icon[data-v-33e45fbd] {\n    padding-top: 3px;\n    font-size: .85em;\n}\n.multiline-header[data-v-33e45fbd] {\n    display: inline-block;\n    text-align: left;\n}    \n", ""]);

// exports
